<template>
  <v-flex>
    <v-card color="white" class="rounded">
      <v-card-title class="mb-0">
        <div class="d-flex align-center">
          <h4 class="subheading">Invoices</h4>
          <!-- <v-btn icon @click.stop="loadOrgInvoices()" :disabled="loading">
            <v-icon title="Refresh" color="secondary">mdi-refresh</v-icon>
          </v-btn> -->
        </div>
      </v-card-title>
      <v-card-text>
        <div>
          <v-data-table
            :headers="headers"
            :items="invoices"
            :loading="loading"
            item-key="date"
            sort-by="date"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:progress>
              <v-progress-linear
                color="#d13b55"
                height="2"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:items="props">
              <td>
                <span
                  >${{
                    props.item.invoice + props.item.additionalSupport
                  }}</span
                >
              </td>
              <td>
                {{ formatDate(props.item.date) }}
              </td>
              <td>
                <v-btn
                  icon
                  @click.stop="downloadPdf(props.item)"
                  :disabled="loading"
                >
                  <v-icon title="Download PDF" color="#d13b55"
                    >mdi-download</v-icon
                  >
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "Invoices",
  data() {
    return {
      loading: false,
      invoices: [],
      headers: [
        { text: "Invoice", value: "invoice" },
        { text: "Date", value: "date" },
        { text: "Action", value: "pdf", sortable: false, width: "100px" },
      ],
    };
  },
  methods: {
    loadOrgInvoices: function () {
      if (
        (this.$store.getters.userIsAdministrativeOrOrgOwner ||
          this.$store.getters.isHRManager) &&
        this.$store.getters.isCurrentOrgSet &&
        !this.$store.getters.isCurrentOrgChild
      ) {
        this.loading = true;
        this.invoices = [];
        axios
          .get(
            "/api/org/invoice/list/" + this.$store.getters.getOrgIdentifier,
            this.$store.state.axiosConfig
          )
          .then((response) => {
            this.invoices = response.data;
            this.loading = false;
          })
          .catch((e) => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    downloadPdf: function (invoiceItem) {
      window.open(
        `${process.env.VUE_APP_SERVICES_URL}/api/org/invoice/download/${
          invoiceItem.subdomain
        }/OrgInvoice.${moment.utc(invoiceItem.date).format("YYYYMMDD")}`
      );
    },
    formatDate: function (date) {
      return moment.utc(date).format("DD MMM YYYY");
    },
  },
  beforeMount() {
    this.loadOrgInvoices();
  },
  watch: {
    // Sync when current org updated/changed
    "$store.state.userSelf.currentOrg.org": function () {
      this.loadOrgInvoices();
    },
  },
};
</script>